/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leo_Display_NameInputs */

const en_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const id_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const ms_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const ca_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA Leo Premium`)
};

const cs_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const da_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const de_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const et_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tasuline Leo AI`)
};

const es_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const fr_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const hr_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const it_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const lv_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo MI Premium`)
};

const lt_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`„Leo Premium“ dirbtinis intelektas`)
};

const hu_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const nl_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const nb_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const pl_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const pt_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const ro_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const sk_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const sl_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const fi_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const sv_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const vi_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const tr_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo YZ Premium`)
};

const el_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const bg_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const ru_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Премиум`)
};

const sr_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const uk_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const ka_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI პრემიუმი`)
};

const hi_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const th_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

const ko_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레오 AI 프리미엄`)
};

const zh_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo 人工智能 Premium`)
};

const zh_tw_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI 高級版`)
};

const ja_leo_display_name = /** @type {(inputs: Leo_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leo AI Premium`)
};

/**
* | output |
* | --- |
* | "Leo AI Premium" |
*
* @param {Leo_Display_NameInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const leo_display_name = /** @type {((inputs?: Leo_Display_NameInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leo_Display_NameInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_leo_display_name(inputs)
	if (locale === "ms") return ms_leo_display_name(inputs)
	if (locale === "ca") return ca_leo_display_name(inputs)
	if (locale === "cs") return cs_leo_display_name(inputs)
	if (locale === "da") return da_leo_display_name(inputs)
	if (locale === "de") return de_leo_display_name(inputs)
	if (locale === "et") return et_leo_display_name(inputs)
	if (locale === "es") return es_leo_display_name(inputs)
	if (locale === "fr") return fr_leo_display_name(inputs)
	if (locale === "hr") return hr_leo_display_name(inputs)
	if (locale === "it") return it_leo_display_name(inputs)
	if (locale === "lv") return lv_leo_display_name(inputs)
	if (locale === "lt") return lt_leo_display_name(inputs)
	if (locale === "hu") return hu_leo_display_name(inputs)
	if (locale === "nl") return nl_leo_display_name(inputs)
	if (locale === "nb") return nb_leo_display_name(inputs)
	if (locale === "pl") return pl_leo_display_name(inputs)
	if (locale === "pt") return pt_leo_display_name(inputs)
	if (locale === "ro") return ro_leo_display_name(inputs)
	if (locale === "sk") return sk_leo_display_name(inputs)
	if (locale === "sl") return sl_leo_display_name(inputs)
	if (locale === "fi") return fi_leo_display_name(inputs)
	if (locale === "sv") return sv_leo_display_name(inputs)
	if (locale === "vi") return vi_leo_display_name(inputs)
	if (locale === "tr") return tr_leo_display_name(inputs)
	if (locale === "el") return el_leo_display_name(inputs)
	if (locale === "bg") return bg_leo_display_name(inputs)
	if (locale === "ru") return ru_leo_display_name(inputs)
	if (locale === "sr") return sr_leo_display_name(inputs)
	if (locale === "uk") return uk_leo_display_name(inputs)
	if (locale === "ka") return ka_leo_display_name(inputs)
	if (locale === "hi") return hi_leo_display_name(inputs)
	if (locale === "th") return th_leo_display_name(inputs)
	if (locale === "ko") return ko_leo_display_name(inputs)
	if (locale === "zh") return zh_leo_display_name(inputs)
	if (locale === "zh-tw") return zh_tw_leo_display_name(inputs)
	if (locale === "ja") return ja_leo_display_name(inputs)
	return en_leo_display_name(inputs)
});